import React, { memo } from 'react';
import CompetitionModuleHeader from 'app/components/competitionModule/header/CompetitionModuleHeader';
import { ModuleWrapper, Separator } from 'app/components/competitionModule/common/styles';
import CompetitionModuleMatches from 'app/components/competitionModule/matches/CompetitionModuleMatches';
import CompetitionModuleLink from 'app/components/competitionModule/link/CompetitionModuleLink';
import CompetitionModuleLatestNews from 'app/components/competitionModule/news/CompetitionModuleLatestNews';
function CompetitionModule(_ref) {
  let {
    data
  } = _ref;
  return /*#__PURE__*/React.createElement(ModuleWrapper, {
    "data-sentry-element": "ModuleWrapper",
    "data-sentry-component": "CompetitionModule",
    "data-sentry-source-file": "CompetitionModule.tsx"
  }, /*#__PURE__*/React.createElement(CompetitionModuleHeader, {
    data: data,
    "data-sentry-element": "CompetitionModuleHeader",
    "data-sentry-source-file": "CompetitionModule.tsx"
  }), /*#__PURE__*/React.createElement(Separator, {
    "data-sentry-element": "Separator",
    "data-sentry-source-file": "CompetitionModule.tsx"
  }), /*#__PURE__*/React.createElement(CompetitionModuleMatches, {
    competitionSlug: data.slug,
    matches: data.matches,
    "data-sentry-element": "CompetitionModuleMatches",
    "data-sentry-source-file": "CompetitionModule.tsx"
  }), /*#__PURE__*/React.createElement(CompetitionModuleLatestNews, {
    moduleIndex: data.moduleIndex,
    news: data.news,
    "data-sentry-element": "CompetitionModuleLatestNews",
    "data-sentry-source-file": "CompetitionModule.tsx"
  }), /*#__PURE__*/React.createElement(CompetitionModuleLink, {
    data: data,
    "data-sentry-element": "CompetitionModuleLink",
    "data-sentry-source-file": "CompetitionModule.tsx"
  }));
}
export default /*#__PURE__*/memo(CompetitionModule);